// export const AUTH = ['auth_organization_management', 'auth_sync_management', 'auth_staff_management', 'auth_login_information_confirmation'];
export const PASS = ['pass_list_user', 'pass_users_management'];
export const LOG = ['saucer_logs', 'sync_logs'];
export const PERMISSION = ['permission_role', 'permission_default_setting'];
export const MANAGEMENT = ['management_ccj_admin', 'management_auth_console_role', 'management_connect_web_services', 'management_modules'];
export const CAREMONI = ['caremoni_organization_management', 'caremoni_device_management'];
export const CAREMONI_APP_TV = [
  'caremoni_app_tv_content_category', // コンテンツ区分一覧
  'caremoni_app_tv_content_list'      // コンテンツ一覧
];
export const CATEGORY_COLUMN_WIDTHS = {
  index: '5%',
  categoryId: '10%',
  menuName: '30%',
  description: '10%',
  contentCount: '15%',
  sortNo: '5%',
  action: '17%'
};
export const SELECT_DIALOG_COLUMN_WIDTHS = {
  select: '5%',
  index: '5%',
  id: '10%',
  name: '30%',
  description: '30%',
  type: '5%',
  showCase: '7%',
  reOrder: '8%'
};

export const CONTENT_LIST_COLUMN_WIDTHS = {
  index: '5%',
  id: '10%',
  name: '23%',
  description: 'auto',
  type: '9%',
  showCase: '15%',
  reOrder: '10%',
  action: '17%'
};
